import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { NzSubmenuService } from "ng-zorro-antd/menu";
import { UiIsMenuInsideDropDownToken } from "../utils/menu.utils";
import { UiMenuService } from "./menu.service";

@Injectable()
export class UiSubmenuService extends NzSubmenuService {
  constructor(
    @SkipSelf() @Optional() uiHostSubmenuService: UiSubmenuService,
    public uiMenuService: UiMenuService,
    @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean
  ) {
    super(uiHostSubmenuService, uiMenuService, isMenuInsideDropDown);
  }
}
